import $ from 'jquery';

const header = () => {
  const mobileButton = $('.js-toggle');
  const menu = $('.js-menu');
  mobileButton.click(() => {
    if ($('html')
      .hasClass('block-scroll')) {
      $('html, body')
        .removeClass('block-scroll');
    } else {
      $('html, body')
        .addClass('block-scroll');
    }
    menu.toggleClass('is_active');
  });

  $('.menu__link--dropdown').click((event) => {
    $(event.currentTarget).next().toggle();
  });

  $(document).click((event) => {
    const $target = $(event.target);
    if (!$target.closest('.menu__link--dropdown').length) {
      $('.menu__sub-item:not(.menu__sub-item--mobile-logout)').hide();
    }
    if (menu.hasClass('is_active') &&
        !menu.is($target) &&
        !mobileButton.is($target) &&
        menu.has($target).length === 0 &&
        mobileButton.has($target).length === 0
    ) {
      menu.removeClass('is_active');
      $('html, body')
        .removeClass('block-scroll');
    }
  });

  let prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    const currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos) {
      $('.header__wrapper').css('top', '0');
    } else if (currentScrollPos > 200) {
      $('.header__wrapper').css('top', '-80px');
    }
    prevScrollpos = currentScrollPos;
  };

  setAuthenticationFunctionality();
};

export default () => {
  header();
};

function setAuthenticationFunctionality() {
  if ($('[data-sf-role="is-logged-in"]').length > 0 && $('[data-sf-role="is-logged-in"]').val() == 'true' && $('[data-js=user-login-link]').length > 0) {
    const isRtl = document.documentElement.lang === 'ar';

    const templateHtml = isRtl ? $('#header-logout-template-ar').html() : $('#header-logout-template').html();
    $('[data-js=user-login-link]').after(templateHtml);
    $('[data-js=user-login-link], [data-mobile-js=user-login-link]').attr('href', isRtl ? '/ar/uaedashboard' : '/uaedashboard');
    $('[data-js=user-login-link]').parent().addClass('menu__item--hovered');

    // Mobile
    $('[data-mobile-js=user-login-link]').parent().after(templateHtml);
    const mobileLogout = $('[data-mobile-js=user-login-link]').parent().next();
    mobileLogout.addClass('menu__sub-item--mobile-logout');
    mobileLogout.css({ display: 'block' });

    $('.menu__user-icon').each(function () {
      const activeUserIcon = '<use xlink:href="/ResourcePackages/UaeInnovates2020/assets/dist/images/icons.svg?v3#icon-login-active"></use>';
      $(this).html(activeUserIcon);
    });
  }
}
